<lib-validation-problems [saving$]="saving$"></lib-validation-problems>
<h3>{{ 'common.labels.parties' | transloco }}</h3>
<lib-parties-list partyTypeTitle="Debtor" [order]="order" [observableParties$]="businessParties" [isEditable]="false"
    [uiConfiguration]="uiConfiguration!.businessPartyConfiguration!">
</lib-parties-list>